export default __webpack_public_path__ + "static/media/vegetable.767c66e2.png";